import { FormField } from '../validators/utils';

const ALLOWABLE_CHARACTERS = ['/', '-', '(', ')', ' ', '+', '$', ','];

export function mask(f: FormField, selectionStart?: number, alpha?: boolean) {
  let field = f.field as HTMLInputElement;
  let mask = f.field.dataset.mask.split('');
  let separatingCharacter = [];
  let maskIndicies = [];

  let alphaReplace = /[^a-zA-Z0-9]/g;
  let numericReplace = /[^0-9]/g;

  mask.filter((m: string, i: number) => {
    if (ALLOWABLE_CHARACTERS.indexOf(m) !== -1) {
      maskIndicies.push(i);
      separatingCharacter.push(mask[i]);
    }
  });

  if (field.value.length > 0) {
    field.value = field.value.replace(alpha ? alphaReplace : numericReplace, '');
    if (maskIndicies && field.value.length > 0) {
      maskIndicies.forEach((maskPosition: number, i: number) => {
        if (field.value.length > maskPosition) {
          field.value = [
            field.value.slice(0, maskPosition),
            separatingCharacter[i],
            field.value.slice(maskPosition),
          ].join('');
        }
      });
    }
  }

  if (selectionStart) {
    // Verify cursor stays in the position the user expects.
    field.selectionEnd = selectionStart;
  }
}
